import {
    // Checkbox,
    Dropdown,
    IconButton,
    IStackStyles,
    Modal,
    PrimaryButton,
    Stack,
    TextField
} from "@fluentui/react";
import React, { FunctionComponent, useEffect, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Col, Row } from "react-grid-system";
import { useDispatch, useSelector } from "react-redux";
//import GoBackToMainDialogBtn from "../addInventoryDialog/GoBackToMainDialogBtn";
import { Link } from "@fluentui/react/lib/Link";
import dropDownsValues from "constants/inventoryDropdownsValues";
import {
    cancelIcon,
    contentStyles as content,
    iconButtonStyles,
} from "constants/styles";
import { useFormik } from "formik";
import { Dropdown as PRDropdown } from 'primereact/dropdown';
import { AppState } from "store";
import { isKarlProfile } from "utils/permissions/permissionsHelpers";
import * as Yup from "yup";
import VinScanner from "../../barCodeScanner/VinScanner.js";
// import { VinCameraSelection} from "components/dialogs/vinCameraSelection/VinCameraSelection";
import { useMediaQuery } from "react-responsive";
import { handleGetAppraisalTrimUsingVin, handleGetAppraisalVehDetails } from "store/oneDaySale/oneDaySale.action";

const contentStyles = content(460, "auto");

interface IProps {
    onDismiss?: (vehicleId, vin?) => void;
    openTrimDialog?: (vehicleId, vin?) => void;
    isvalidSale?:any;
}

const yearValues = dropDownsValues.yearNewValues.map((item) => {
    return { key: item, text: item };
});

export const AddVehicleAppraisalDialog: FunctionComponent<IProps> = ({
    onDismiss,
    openTrimDialog,
    isvalidSale
}) => {
    const [vehicleType, setvehicleType] = useState('vin');
    const [isInventoryYMM, setisInventoryYMM] = useState(false);
    const [isVINScan, setisVINScan] = useState(false);
    const [vinDataError, setvinDataError] = useState(false);
    const [trimError, setTrimErrorr] = useState(false);
    const [vinDecodeError, setVinDecodeError] = useState(false);
    const isMobile = useMediaQuery({ maxWidth: 768 });
    const [commonServerError, setcommonServerError] = useState(null);
    const userProfile: any = useSelector(
        (state: AppState) => state.userProfile.userProfile
    );
    const dispatch = useDispatch();

    const isKarlProfileType = userProfile.profileType && isKarlProfile(userProfile.profileType);

    Yup.addMethod(Yup.string, 'vinOnly', function (message) {
        if (isKarlProfileType) {
            return (this.max(50, 'Must be less than 50 character'))
        } else {
            return (this.matches(/^[A-Z0-9]{17}$/,
                "Must Contain at 17 Characters, Uppercase letters and numbers"))
        }
    });

     Yup.addMethod(Yup.object, 'modelOnly', function (message) {
         return (vehicleType === 'make');
     });

     Yup.addMethod(Yup.number, 'yearOnly', function (message) {
         return (vehicleType === 'make');
     });

     useEffect(() => {
        setvehicleType('vin');
        // eslint-disable-next-line react-hooks/exhaustive-deps       
    }, []);

    const formik = useFormik({
        initialValues: {
            make: "",
            model: "",
            year: new Date().getFullYear(),
            vin: "",
            orderNumber: "",
            stockNumber: ""
        },
        validationSchema: Yup.object({
            make: Yup.string().max(50, "Make must be at most 50 characters").required("Required"),
            model: Yup.string().max(50, "Model must be at most 50 characters").required("Required"),
            year: Yup.number().yearOnly(),
            stockNumber: Yup.string(),
            vin: Yup.string().vinOnly(),
            orderNumber: Yup.string(),
        }),
        onSubmit: (values) => {
        },
    });


    const handleSubmit = () => {
        if (isvalidSale) {
            handleAddInventory()
        } else {
            setcommonServerError("Sale Date,Tag,Customer name,Customer phone,Status,Location are required")
        }
    }

    const handleAddInventory = () => {
        setvinDataError(false);
        setVinDecodeError(false);
        setTrimErrorr(false);
        dispatch<any>(handleGetAppraisalTrimUsingVin({
            vin: formik.values.vin,
            callback: (trimData) => {
                 if (!trimData.status) {
                     if (trimData.style.length === 0) {
                         setvinDataError(true);
                            setVinDecodeError(true);
                     } else if (trimData.style.length > 1) {
                         const values = trimData.style.map((item, index) => {
                             return { key: item, text: item };
                         });
                         // settrimValues(values);
                         openTrimDialog({
                             vin: formik.values.vin,
                             trim: values,
                             ymm: null
                         });

                     } else if (trimData.style.length === 1) {
                         let vinTrim = {
                             style: trimData.style[0],
                             vin: formik.values.vin
                         }
                         dispatch<any>(handleGetAppraisalVehDetails({
                             vehDet: vinTrim,
                             callback: (success) => {
                                 if (success) {
                                    onDismiss(null);
                                 } else {
                                      setvinDataError(true);
                                      setVinDecodeError(true)
                                 }
                             }
                         }));
                     }
                 } else {
                     if (trimData.status === 409) {
                         onDismiss(trimData.data, formik.values.vin);
                     } else if (trimData.status === 500) {
                         setTrimErrorr(true);
                     }
                     else {
                         setvinDataError(true);
                         setVinDecodeError(true)
                     }
                 }
            }
        }));
    };

    const handleAddYmmInventory = () => {
        if (!isvalidSale) {
            setcommonServerError("Sale Date,Tag,Customer name,Customer phone,Status,Location are required");
        }else{
            let ymm = {
                make: formik.values.make,
                model: formik.values.model,
                year: formik.values.year,
            };
            if(formik.values.vin ){
                ymm['vin'] = formik.values.vin;
             }
    
            dispatch<any>(handleGetAppraisalVehDetails({    
                vehDet:ymm,
                callback: (success) => {
                    if (success.id) {
                          onDismiss(null);
                    } else {
                        setvinDataError(true);
                     }
                }
            }));
        }
    };


    const handleYearChange = (value) => {
        formik.setValues(
            {
                ...formik.values,
                year: value ? value : '',
                make: '',
                model: ''
            }
        );
    };

    const handleVINYmm = (bool) => {
        setvinDataError(false);
        setTrimErrorr(false);
        setVinDecodeError(false);
        setisInventoryYMM(bool);
        if (bool) {
            formik.setValues(
                {
                    ...formik.values,
                    vin: '',
                }
            );
        } else {
            formik.setValues(
                {
                    ...formik.values,
                    year: new Date().getFullYear() + 1,
                    make: '',
                    model: '',
                    orderNumber: ''
                }
            );
        }
    };

    const handleScanVIN = (bool, fromCamera = false) => {
        if (fromCamera) {
            // setvinCameraDialog(true);
        }
        setvinDataError(false);
        setVinDecodeError(false);
        setTrimErrorr(false);
        setisVINScan(bool)
    }

    const onScanSubmit = (vin) => {
        let capturedVIN = vin.split(',');
        // When scanned with QR Code, contains multiple options. so picking VIn data alone
        let truncatedVIn = capturedVIN[0];
        if (capturedVIN[0].length === 18) {
            // When contains LEADING letter I
            truncatedVIn = capturedVIN[0].substring(1);
        }
        formik.setFieldValue("vin", truncatedVIn.trim().toUpperCase());
        handleScanVIN(false);
    }

    const changeToUppercase = (e: any) => {
        const re = /^[a-zA-Z0-9]*$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            //this.setState({ value: e.target.value })
            formik.setFieldValue("vin", e.target.value.trim().toUpperCase());
        }
    };

    const onBackDismiss = () => {
        if (isVINScan) {
            handleScanVIN(false)
        }
        else {
            onDismiss('')
        }
    }

    return (
        <>
            <Modal
                isOpen={true}
                onDismiss={onBackDismiss}
                isBlocking={true}
                className={"ymm-dialog-karl"}
                containerClassName={`${contentStyles.container} inv-srch-mod ${isVINScan ? 'scanner' : ''}`}
            >
                <div className={contentStyles.header + " inventory-popup"} style={{ marginBottom: '-20px' }}>
                    <h1 className="formTitle">Add Vehicle</h1>
                    <IconButton
                        styles={iconButtonStyles}
                        iconProps={cancelIcon}
                        ariaLabel="Close popup modal"
                        onClick={onBackDismiss}
                    />
                </div>

                <div className={`${contentStyles.body} inv-srch-bdy body-auto-hight`}>
                {
                   commonServerError ?
                           <div
                           style={{
                            wordWrap: 'break-word',
                            overflowWrap: 'break-word',
                            whiteSpace: 'normal',
                            maxWidth: '100%',
                            padding:'15px'
                          }}
                               className="genericErrorColor text-left"
                           >
                               <span>{commonServerError}</span>
                           </div>
                        : null
               }
                    <Stack
                        styles={stackStyles}
                        verticalAlign="start"
                        horizontalAlign="space-between"
                    >
                        <div className={isInventoryYMM ? "ymm-body addInventoryDialog" : " vin-body-new addInventoryDialog"}>
                            {
                                vinDecodeError && isKarlProfileType && isInventoryYMM === false ?
                                    <div>
                                        <Row>
                                            <Col>
                                                <p className="genericErrorColor"><span>VIN is not recognized, please validate and re-enter VIN.</span></p>
                                                <p className="genericErrorColor"><span>Note:  Heavy duty trucks, specialty vehicles, and other VINs may not decode. Click "Add vehicle manually" to add these vehicles. </span></p>
                                            </Col>
                                        </Row>
                                    </div> : null
                            }
                            {
                                vinDataError && isKarlProfileType && isInventoryYMM ?
                                    <div>
                                        <Row>
                                            <Col>
                                                <p className="genericErrorColor"><span>VIN is not recognized, please re-enter VIN.</span></p>
                                            </Col>
                                        </Row>
                                    </div> : null
                            }
                            {
                                trimError ?
                                    <div>
                                        <Row>
                                            <Col>
                                                <p className="genericErrorColor"><span>Faild to fetch data.</span></p>
                                            </Col>
                                        </Row>
                                    </div> : null
                            }
                            {isInventoryYMM ?
                                <div>
                                    {(isVINScan && isKarlProfileType) ?
                                        <>
                                            <VinScanner
                                                vinSelection={"barcode"}
                                                onScanSubmit={(vin) => onScanSubmit(vin)} />
                                        </>
                                        :
                                        <>
                                            {isMobile ?

                                                <div>

                                                    <Row className="inventoryRowSection" justify="center">
                                                        <Col className="inventoryColDivider" sm={11} md={11} xs={12}>
                                                            <Dropdown
                                                                id="model_addInventory"
                                                                label="Year"
                                                                selectedKey={formik.values.year}
                                                                required={true}
                                                                onChange={(e, item) => handleYearChange(item.key)}
                                                                placeholder="Select a Year"
                                                                options={yearValues}

                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="inventoryRowSection" justify="center">
                                                        <Col className="inventoryColDivider" sm={11} md={11} xs={12}>

                                                            <TextField
                                                                id="make"
                                                                name="make"
                                                                label="Make"
                                                                placeholder=""
                                                                className="employeeeSearchLabelText"
                                                                value={formik.values.make}
                                                                required={true}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                            />

                                                        </Col>
                                                    </Row>
                                                    <Row className="inventoryRowSection" justify="center">
                                                        <Col className="inventoryColDivider" sm={11} md={11} xs={12}>
                                                            <TextField
                                                                id="model"
                                                                name="model"
                                                                label="Model"
                                                                placeholder=""
                                                                className="employeeeSearchLabelText"
                                                                value={formik.values.model}
                                                                required={true}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                            />
                                                        </Col>
                                                    </Row>

                                                </div>

                                                :
                                                <div>
                                                    <Row className="inventoryRowSection" justify="center">
                                                        <Col sm={10} md={10} xs={12} >
                                                            <div className="yearMake">
                                                                <h5 className="primeDropdownLabel" style={{ margin: "5px 0" }}>Year</h5>
                                                                <PRDropdown
                                                                    id="model_addInventory"
                                                                    value={formik.values.year}
                                                                    className="invMakeDropdown labelTextBorder full-width"
                                                                    options={yearValues}
                                                                    onChange={(e) => handleYearChange(e.value)}
                                                                    optionLabel="text"
                                                                    optionValue="text"
                                                                    scrollHeight="150px"
                                                                    virtualScrollerOptions={{ itemSize: 31 }}
                                                                    placeholder="Select a Year"
                                                                    appendTo="self"
                                                                    filter
                                                                    resetFilterOnHide={true}
                                                                    required={true} />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row className="inventoryRowSection" justify="center">
                                                
                                                                <Col sm={10} md={10} xs={12}>
                                                                    <TextField
                                                                        id="make"
                                                                        name="make"
                                                                        label="Make"
                                                                        placeholder=""
                                                                        className="employeeeSearchLabelText"
                                                                        value={formik.values.make}
                                                                        required={true}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}

                                                                    />
                                                                </Col>
                                                      
                                                    </Row>
                                                    <Row className="inventoryRowSection" justify="center">
                                                                <Col sm={10} md={10} xs={12}>
                                                                    <TextField
                                                                        id="model"
                                                                        name="model"
                                                                        label="Model"
                                                                        placeholder=""
                                                                        className="employeeeSearchLabelText"
                                                                        value={formik.values.model}
                                                                        required={true}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}

                                                                    />
                                                                </Col>
                                                    </Row>
                                                </div>

                                            }
                                            {isKarlProfileType ?

                                                <div>
                                                    <Row className="inventoryRowSection" justify="center">
                                                        <Col sm={10} md={10} xs={12} >
                                                            <TextField
                                                                id="vin"
                                                                name="vin"
                                                                label="VIN"
                                                                iconProps={{ iconName: "Camera", style: { pointerEvents: "auto", cursor: "pointer" }, onClick: () => handleScanVIN(true, true) }}
                                                                value={formik.values.vin}
                                                                className="employeeeSearchLabelText"
                                                                onChange={changeToUppercase}
                                                                onBlur={formik.handleBlur}
                                                                errorMessage={
                                                                    formik.touched.vin &&
                                                                    formik.errors.vin &&
                                                                    formik.errors.vin.toString()
                                                                }
                                                            />
                                                        </Col>
                                                    </Row>

                                                </div>

                                                : ''}
                                            <Row className="noVin" justify="center">
                                                <Col sm={10} md={10} xs={12}>
                                                    <Link onClick={() => handleVINYmm(false)}>
                                                        {isKarlProfileType ? "Add vehicle by VIN" : "I have a VIN"}
                                                    </Link>
                                                </Col>
                                            </Row>
                                            <Row className="inventoryRowSection ymm" justify="center">
                                                <Col sm={10} md={10} xs={12} className="submitBtn">
                                                    <PrimaryButton
                                                        className="decodeBtn"
                                                        disabled={!formik.values.make || !formik.values.model}
                                                        // onRenderIcon={renderSpinner}
                                                        text={isKarlProfileType ? "Save" : "Search"}
                                                        onClick={handleAddYmmInventory}
                                                    />
                                                </Col>
                                            </Row>
                                        </>}
                                </div>
                                :
                                <div>
                                    {isVINScan ?

                                        <VinScanner
                                            vinSelection={"barcode"}
                                            onScanSubmit={(vin) => onScanSubmit(vin)}
                                        />
                                        :
                                        <div>
                                            <Row className="inventoryRowSection inventorySplitRow autoWidthInput" justify="center">
                                                <Col className="inventoryColDivider" sm={11} md={11} xs={12}>
                                                    <TextField
                                                        id="vin"
                                                        name="vin"
                                                        label="VIN"
                                                        iconProps={{ iconName: "Camera", style: { pointerEvents: "auto", cursor: "pointer" }, onClick: () => handleScanVIN(true, true) }}
                                                        value={formik.values.vin}
                                                        onChange={changeToUppercase}
                                                        onBlur={formik.handleBlur}
                                                        errorMessage={
                                                            formik.touched.vin &&
                                                            formik.errors.vin &&
                                                            formik.errors.vin.toString()
                                                        }
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className="noVin" justify="center">
                                                <Col sm={11} md={11} xs={12}>
                                                    <Link onClick={() => {handleVINYmm(true);setcommonServerError('')}}>
                                                        {isKarlProfileType ? "Add vehicle manually" : "I don't have the VIN"}
                                                    </Link>
                                                </Col>
                                            </Row>

                                            <Row className="inventoryRowSection ymm" justify="center">
                                                <Col sm={10} md={10} xs={12} className="submitBtn">
                                                    <PrimaryButton
                                                        disabled={formik.errors.vin || !formik.values.vin ? true : false}
                                                        className="decodeBtn"
                                                        text="Search"
                                                        onClick={handleSubmit}
                                                    />
                                                </Col>
                                            </Row>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </Stack>
                </div>
            </Modal>
        </>
    );
};

const stackStyles: IStackStyles = {
    root: {},
};
